import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { indianPincode } from "~/src/app/shared/validators/indian-pincode.validator";
import { nameValidator } from "src/app/shared/name-validator.directive";
import { BaseAddress, AddressDetailsAttributes } from "@models/user.model";
import { noSpacesValidator } from "../../shared/shared/no-leading-space-validator.directive";
import { debounceTime } from "rxjs";
import { indianPhoneNumber } from "../../shared/validators/indian-phone-number.validator";
import { MatCheckboxChange } from "@angular/material/checkbox";
import { UserService } from "../../services/user/user.service";
import { AuthService } from "../../services/auth/auth.service";
import { CheckoutService } from "../../services/checkout-page/checkout.service";

@Component({
    selector: "app-address",
    templateUrl: "./address.component.html",
    styleUrls: ["./address.component.scss"],
    standalone: false,
})
export class AddressComponent implements OnChanges {
    public addressForm!: FormGroup;
    public isSetAsDefault: boolean = false;
    public showDefaultAddress: boolean = false;
    public address!: AddressDetailsAttributes;

    // @Input() location!: AddressDetailsAttributes;
    @Output() addressData = new EventEmitter<AddressDetailsAttributes>();
    @Input() selectedAddressId!: number;
    @Input() showNameAndMobile: boolean = false;
    @Input() isInDialog: boolean = false;

    constructor(
        private formBuilder: FormBuilder,
        private userService: UserService,
        private auth: AuthService,
        private checkoutService: CheckoutService,
    ) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (this.selectedAddressId) {
            this.userService.getAddress(this.selectedAddressId).subscribe((response) => {
                this.address = response as AddressDetailsAttributes;
                if (this.address) {
                    this.patchForm();
                }
            });
        }
    }

    ngOnInit(): void {
        if (this.auth.isUserLoggedIn) {
            this.userService.isUserDetailsExist().subscribe((response) => {
                this.showDefaultAddress = response;
            });
        } else {
            this.showDefaultAddress = false;
        }

        this.addressForm = this.formBuilder.group({
            name: [
                { value: "", disabled: !this.showNameAndMobile },
                [Validators.required, nameValidator(), noSpacesValidator()],
            ],
            mobileNumber: [
                { value: "", disabled: !this.showNameAndMobile },
                [Validators.required, indianPhoneNumber()],
            ],
            address: ["", [Validators.required, noSpacesValidator()]],
            houseNumber: ["", [Validators.required, noSpacesValidator()]],
            city: ["", [Validators.required, noSpacesValidator()]],
            state: ["", [Validators.required, noSpacesValidator()]],
            pincode: ["", [Validators.required, indianPincode()]],
            addressType: ["", Validators.required],
            isDefault: [false],
        });

        // this.addressForm.valueChanges.subscribe(data => {
        //   // if (this.addressForm.valid && this.location && this.location.gpsCoordinate) {
        //   //   const addressData = { ...data, gpsCoordinate: { latitude: this.location.gpsCoordinate.latitude, longitude: this.location.gpsCoordinate.longitude } };
        //   //   this.addressData.emit(addressData);
        //   // }

        //   if (this.addressForm.valid) {
        //     const addressData = { ...data, id: this.selectedAddress?.id };
        //     this.addressData.emit(addressData);
        //   }
        // });

        this.subscribeToFormChanges();
    }

    private subscribeToFormChanges(): void {
        this.addressForm.valueChanges.pipe(debounceTime(300)).subscribe(() => {
            if (this.addressForm.valid) {
                const rawData = this.addressForm.getRawValue();
                const addressData = {
                    ...rawData,
                    name: rawData.name?.trim(),
                    address: rawData.address?.trim(),
                    houseNumber: rawData.houseNumber?.trim(),
                    city: rawData.city?.trim(),
                    state: rawData.state?.trim(),
                    id: this.address?.id,
                    isDefault: this.showDefaultAddress ? (this.isSetAsDefault ? true : this.address?.isDefault) : true,
                };
                this.addressData.emit(addressData);
            }
        });
    }

    public onValidNumber(event: Event): void {
        const inputElement = event.target as HTMLInputElement;
        const value = inputElement.value;

        // Remove any non-numeric characters
        inputElement.value = value.replace(/[^0-9]/g, "");
    }

    private patchForm(): void {
        this.addressForm.patchValue({
            name: this.address?.name,
            mobileNumber: this.address?.mobileNumber,
            address: this.address?.address,
            houseNumber: this.address?.houseNumber,
            city: this.address?.city,
            state: this.address?.state,
            pincode: this.address?.pincode,
            addressType: this.address?.addressType,
            isDefault: this.address?.isDefault,
        });
    }

    public isInvalid(controlName: string, validatorName?: string): boolean {
        const contorl = this.addressForm.get(controlName);
        if (validatorName) {
            return contorl!.errors?.[validatorName];
        }
        return contorl!.invalid && contorl!.touched;
    }

    // public receiveLocationData(location: AddressDetailsAttributes): void {
    //   this.location = location;
    // }

    /* To toggle Set as Default Checkbox  */
    public toggleDefault(event: MatCheckboxChange): void {
        this.isSetAsDefault = event.checked;
    }
}
